import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { getProveedores } from "../../../functions/api/proveedores";
import { getTrabajoById, updateTrabajo } from "../../../functions/api/trabajos";
import SolicitudAdminForm from "../../../components/forms/solicitudesDetail/SolicitudAdminForm";
import {
  downloadFile,
  getArchivosSolicitud,
  uploadFile,
} from "../../../functions/api/archivos";
import AdminSidebar from "../../../components/nav/AdminSidebar";

const comentarioState = {
  usuario: "",
  fecha: "",
  fechaComentario: "",
  titulo: "",
  tipoComentario: "",
  descripcion: "",
};

const repuestoState = {
  cantRep: "",
  descRep: "",
};

const SolicitudesDetailAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [naves, setNaves] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [values, setValues] = useState("");
  const [rep, setRep] = useState([]);
  const [repuestosData, setRepuestosData] = useState(repuestoState);
  const [observacionesData, setObsevaciones] = useState([]);
  const [comentario, setComentario] = useState(comentarioState);
  const [adjuntosData, setAdjuntosData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [nuevoEstado, setNuevoEstado] = useState("");
  const [cotizaciones, setCotizaciones] = useState([{ nro: "", fecha: "" }]);
  const [solpeds, setSolpeds] = useState([{ nro: "", fecha: "" }]);
  const [ocs, setOcs] = useState([{ nro: "", fecha: "" }]);

  let navigate = useNavigate();
  let { user } = useSelector((state) => ({ ...state }));

  let { id } = useParams();

  useEffect(() => {
    setLoading(true);

    const delay = 500;

    const timer = setTimeout(() => {
      setLoading(false);

      loadTrabajo();
      loadProveedores();
      loadAdjuntos();
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const parseDocEntries = (nroField, fechaField) => {
    if (!nroField && !fechaField) return [{ nro: "", fecha: "" }];
    try {
      const parsed = JSON.parse(nroField);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
    return [{ nro: nroField || "", fecha: fechaField || "" }];
  };

  const loadTrabajo = () =>
    getTrabajoById(user.token, { id: id }).then((res) => {
      const data = res.data[0];
      setValues(data);
      setCotizaciones(parseDocEntries(data.nrocot, data.fechacotizacion));
      setSolpeds(parseDocEntries(data.nrosolped, data.fechasolped));
      setOcs(parseDocEntries(data.nrooc, data.fechaoc));
    });
  const loadProveedores = () =>
    getProveedores(user.token).then((res) => setProveedores(res.data));
  const loadAdjuntos = () =>
    getArchivosSolicitud(user.token, { id_trabajo: id }).then((res) =>
      setAdjuntosData(res.data),
    );

  const {
    fecha_falla,
    idclasificacion,
    nombre_activo,
    nombre_item,
    severidad,
    fecha_programada,
    clasificacion,
    nrocot,
    fechacotizacion,
    nrosolped,
    fechasolped,
    nrooc,
    fechaoc,
    respuestos,
    nombresolicitante,
    nombreaprobador,
    imagenes,
    observaciones,
    estado_general,
    estado_buque,
    estado_supervisor,
  } = values;

  const {
    titulo,
    fecha,
    usuario,
    fechaComentario,
    descripcion,
    tipoComentario,
  } = comentario;

  const { cantRep, descRep } = repuestosData;

  const obs = values && JSON.parse(observaciones);

  const handleDocEntryChange = (type, index, field, value) => {
    const setters = {
      cotizaciones: setCotizaciones,
      solpeds: setSolpeds,
      ocs: setOcs,
    };
    const states = { cotizaciones, solpeds, ocs };
    const updated = [...states[type]];
    updated[index] = { ...updated[index], [field]: value };
    setters[type](updated);
  };

  const addDocEntry = (type) => {
    const setters = {
      cotizaciones: setCotizaciones,
      solpeds: setSolpeds,
      ocs: setOcs,
    };
    const states = { cotizaciones, solpeds, ocs };
    setters[type]([...states[type], { nro: "", fecha: "" }]);
  };

  const removeDocEntry = (type, index) => {
    const setters = {
      cotizaciones: setCotizaciones,
      solpeds: setSolpeds,
      ocs: setOcs,
    };
    const states = { cotizaciones, solpeds, ocs };
    const updated = states[type].filter((_, i) => i !== index);
    setters[type](updated.length ? updated : [{ nro: "", fecha: "" }]);
  };

  const syncDocEntries = () => {
    values.nrocot = JSON.stringify(cotizaciones);
    values.fechacotizacion = null;
    values.nrosolped = JSON.stringify(solpeds);
    values.fechasolped = null;
    values.nrooc = JSON.stringify(ocs);
    values.fechaoc = null;
  };

  const handleSaveDocEntries = (e) => {
    e.preventDefault();
    syncDocEntries();
    updateTrabajo(user.token, values)
      .then((r) => {
        toast.success("Documentos contables guardados con éxito");
        loadTrabajo();
      })
      .catch((err) => console.log(err));
  };

  const handleDownloadFile = (e, ruta) => {
    e.preventDefault();
    downloadFile(user.token, ruta)
      .then((res) => {
        toast.success("Documento descargado exitosamente");
      })
      .catch((err) => console.log(err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    values.observaciones = JSON.stringify(obs.concat(observacionesData));

    updateTrabajo(user.token, values)
      .then((r) => {
        toast.success("Solicitud actualizada con éxito");
        setObsevaciones([]);
        navigate(`/admin/mis-solicitudes/${id}`);
      })
      .catch((err) => console.log(err));
  };

  const handleNuevoEstadoChange = (e) => {
    setNuevoEstado(e.target.value);
  };

  const handleChangeEstado = (e) => {
    e.preventDefault();

    if (nuevoEstado === "") {
      return toast.error("Seleccione un estado");
    }

    values.observaciones = JSON.stringify(obs.concat(observacionesData));

    const estadoG = JSON.parse(estado_general);

    const estadoValue = {
      estado: nuevoEstado,
      fecha: new Date(),
    };

    const newEstado = [...estadoG, estadoValue];

    values.estado_general = JSON.stringify(newEstado);

    updateTrabajo(user.token, values)
      .then((r) => {
        toast.success("Estado actualizado con éxito");
        setObsevaciones([]);
        setNuevoEstado("");
        navigate(`/admin/mis-solicitudes/${id}`);
      })
      .catch((err) => console.log(err));
  };

  const handleComentarioChange = (e) => {
    setComentario({ ...comentario, [e.target.name]: e.target.value });
  };

  const deleteItem = (index) => {
    const updatedArray = [...observacionesData];
    updatedArray.splice(index, 1);
    setObsevaciones(updatedArray);
  };

  const handleAddDataObs = (e) => {
    e.preventDefault();

    if (titulo === "") {
      toast.error("Falta agregar título");
    } else if (fecha === "") {
      toast.error("Falta agregar fecha");
    } else if (tipoComentario === "") {
      toast.error("Falta seleccionar tipo de comentario");
    } else if (descripcion === "") {
      toast.error("Falta agregar descripción");
    } else {
      const currentDate = new Date();
      comentario.usuario = user.nombre;
      comentario.fechaComentario = currentDate;
      setObsevaciones((prevData) => [...prevData, comentario]);
      setComentario(comentarioState);
    }
  };

  const handleFileChange = (event) => {
    setSelectedFiles([...event.target.files]);
  };

  const handleFileUpload = (e) => {
    e.preventDefault();

    selectedFiles.forEach((file) => {
      let params = {};

      params.idTrabajo = values.id;
      params.nombre_documento = file.name;

      uploadFile(user.token, params, file)
        .then((res) => {
          toast.success("Archivo subido exitosamente.");
          loadTrabajo();
          loadAdjuntos();
          setSelectedFiles([]);
        })
        .catch((err) => console.log(err));
    });
  };

  return (
    <div>
      <AdminSidebar />
      <div className="home">
        <div className="navCentro">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <i className="fa-solid fa-screwdriver-wrench"></i> Solicitud de
              Trabajo
            </li>
            <li className="breadcrumb-item">Solicitud N° {id}</li>
          </ol>
        </div>
        <div className="row">
          <div className="col-md-12">
            <SolicitudAdminForm
              values={values}
              repuestosData={repuestosData}
              comentario={comentario}
              observacionesData={observacionesData}
              deleteItem={deleteItem}
              handleComentarioChange={handleComentarioChange}
              handleAddDataObs={handleAddDataObs}
              handleSubmit={handleSubmit}
              handleChangeEstado={handleChangeEstado}
              nuevoEstado={nuevoEstado}
              handleNuevoEstadoChange={handleNuevoEstadoChange}
              adjuntosData={adjuntosData}
              handleDownloadFile={handleDownloadFile}
              selectedFiles={selectedFiles}
              handleFileChange={handleFileChange}
              handleFileUpload={handleFileUpload}
              cotizaciones={cotizaciones}
              solpeds={solpeds}
              ocs={ocs}
              handleDocEntryChange={handleDocEntryChange}
              addDocEntry={addDocEntry}
              removeDocEntry={removeDocEntry}
              handleSaveDocEntries={handleSaveDocEntries}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolicitudesDetailAdmin;
